import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
} from "@mui/material";
import type { User } from "../../types/DB2";

type Props = {
  open: boolean;
  onClose: () => void;
  onSave: (userId: string, newPassword: string) => Promise<void> | void;
  user?: User | null;
};

const UpdatePasswordModal: React.FC<Props> = ({ open, onClose, onSave, user }) => {
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!open) {
      setPassword("");
      setSubmitting(false);
    }
  }, [open]);

  const handleSubmit = async () => {
    if (!user) return;
    if (!password) return;
    setSubmitting(true);
    try {
      await onSave(user.email, password);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Update Password</DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
          {user && (
            <Typography variant="body2" color="text.secondary">
              Updating password for: {user.email ?? user.name ?? user.id}
            </Typography>
          )}
          <TextField
            label="New Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            autoFocus
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" disabled={submitting || !password}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdatePasswordModal;